exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor {\n  cursor: pointer;\n}\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px white inset !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/style/main.less
// module id = ../../../../../src/app/style/main.less
// module chunks = main